import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { AdvocatesForPetition } from './petitionAdvocates.graphql';
import type { AdvocatesForPetitionQuery, AdvocatesForPetitionQueryVariables } from './petitionAdvocates.graphql.d.ts';

export async function getPetitionAdvocates(
	utilityContext: UtilityContext,
	variables: AdvocatesForPetitionQueryVariables,
) {
	const {
		gql: { fetch },
	} = utilityContext;
	const { data } = await fetch<AdvocatesForPetitionQuery, AdvocatesForPetitionQueryVariables>({
		query: AdvocatesForPetition,
		variables,
		rejectOnError: true,
		// to separate query from other batched queries
		batched: false,
	});

	return data;
}
